/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
export const environment = {
  production: true,
  apiUrl: '__{API_URL}__',
  weburl: '__{WEB_URL}__',
  mixpanelToken: '__{MIXPANEL_TOKEN}__',
  auctionOnTheAirBaseUrl: '__{AUCTION_ON_THE_AIR_BASE_URL}__'
};
